/**
 * ?preview=true marks this load as a preview render of a screen (central
 * includes it on every preview URL). Sole source of preview state for v2;
 * constant for the lifetime of the page.
 */
const preview =
  typeof window !== "undefined" &&
  new URLSearchParams(window.location.search).get("preview") === "true";

/** /preview renders a single spot driven over postMessage (docs/Preview.md). */
const previewRoute =
  typeof window !== "undefined" && window.location.pathname === "/preview";

function isPreviewMode(): boolean {
  return preview;
}

function isPreviewRoute(): boolean {
  return previewRoute;
}

function currentEnvironment(): "preview" | "production" {
  return preview ? "preview" : "production";
}

export { isPreviewMode, isPreviewRoute, currentEnvironment };
